import { createBrowserHistory } from 'history';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Drafts from './Drafts/Drafts';
import Gallery from './Gallery/Gallery';
import List from './List/List';
import classes from './Log.module.css';
import SideBySideView from './SideBySideView/SideBySideView';
import Timeline from './Timeline/Timeline';
import NoLogsSelected from 'assets/images/liefIcons/no-logs-selected.png';
import LogSubNav from 'containers/Navigation/LogSubNav/LogSubNav';
import { categoryImages, sortArrayOfObjectsAlphabetically, updateObject } from 'shared/utility';
import * as actions from 'store/actions';

class Log extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: 'timeline',
      postViewSize: 'large',
      showGiftsDrafts: false,
      postsPerQuery: 50,
      currentPageNumber: 1,
      prevPostId: null,
      filters: {
        logIds: [],
        categories: [],
        tags: {
          locationTags: [],
          whatTags: [],
          whoTags: [],
        },
        memberIds: [],
        keywords: [],
        dateStart: '',
        locations: [],
        fileType: '',
        seasons: [],
        unreadOnly: false,
      },
      sortColumns: {
        DateStart: {
          sortOrder: 'desc',
        },
        DateCreated: {
          sortOrder: 'desc',
        },
        DatePostUpdated: {
          sortOrder: 'desc',
        },
      },
      selectedSortColumn: 'DateStart',
      // filtersHeight: 0,
    };
  }

  componentDidMount() {
    const prevPostId =
      this.props.history.location.state &&
      this.props.history.location.state.prevPath === 'posts' &&
      this.props.history.location.state.postId &&
      this.props.history.location.state.edited === false &&
      this.props.currentLogs.Posts.filter((post) => post.Post.PostId === this.props.history.location.state.postId).length > 0
        ? this.props.history.location.state.postId
        : null;
    const browserHistory = createBrowserHistory();
    // If prevPostId, this data is already in state, no need to fetch
    if (!prevPostId && this.props.isAuthenticated) {
      this.props.onFetchTags();
      this.props.onFetchMembersForLogs();
      this.props.onFetchImportantPlaces();
    } else {
      // Delete browser state details on previous path, so that we're not acting off of old information
    }

    browserHistory.replace({ state: { scrollTop: this.props.history.location.state ? this.props.history.location.state : null }, key: '' });
    this.setState({ prevPostId });
    this.setSortAndView();
  }

  componentDidUpdate(prevProps) {
    const currentView = this.props.match.path.replace('/life-shared/', '').replace('/', '');
    // Handle user toggling different view
    if (currentView !== this.state.currentView) {
      this.setState({ currentView });
    }
    if (this.props.postingAs.UserId !== prevProps.postingAs.UserId && prevProps.postingAs.UserId !== null) {
      this.handleFiltersAndStoreReset();
    }
  }

  handleFiltersAndStoreReset = () => {
    const updatedFilters = {
      logIds: [],
      categories: [],
      tags: { locationTags: [], whatTags: [], whoTags: [] },
      memberIds: [],
      keywords: [],
      dateStart: '',
      locations: [],
      fileType: '',
      seasons: [],
      unreadOnly: false,
    };
    this.setState({ filters: updatedFilters, selectedSortColumn: 'DateStart', currentView: 'timeline', postViewSize: 'large' });
    localStorage.removeItem('logFilters');
    localStorage.removeItem('logSortBy');
    localStorage.removeItem('postViewSize');
  };

  getFiltersFromLocalStorage = () => {
    const filters = { ...this.state.filters };
    const localStorageFilters = localStorage.getItem('logFilters') ? JSON.parse(localStorage.getItem('logFilters')) : null;
    if (localStorageFilters) {
      Object.entries(localStorageFilters).forEach((filter) => {
        filters[filter[0]] = filter[1];
      });
    }
    return filters;
  };

  getSortColumnsLocalStorage = () => {
    const localStorageSortBy = localStorage.getItem('logSortBy') ? JSON.parse(localStorage.getItem('logSortBy')) : null;
    if (localStorageSortBy && localStorageSortBy.sortProperty && localStorageSortBy.sortOrder) {
      return this.updatedSortColumsnOrder(localStorageSortBy.sortProperty, localStorageSortBy.sortOrder);
    }
    return this.state.sortColumns;
  };

  setSortAndView = () => {
    const currentView = this.props.match.path.replace('/life-shared/', '').replace('/', '');
    const filters = this.getFiltersFromLocalStorage();
    const selectedSortColumn =
      localStorage.getItem('logSortBy') && JSON.parse(localStorage.getItem('logSortBy')).sortProperty
        ? JSON.parse(localStorage.getItem('logSortBy')).sortProperty
        : this.state.selectedSortColumn;
    const postViewSize = localStorage.getItem('postViewSize') ? localStorage.getItem('postViewSize') : 'large';
    const sortColumns = this.getSortColumnsLocalStorage();
    this.setState({
      currentView,
      filters,
      sortColumns,
      selectedSortColumn,
      postViewSize,
    });
  };

  handleSideDrawerToggle = () => {
    this.setState({ showSideDrawer: !this.state.showSideDrawer });
  };

  handleAddPostLaunch = () => {
    this.props.onInitPostForm(null, false, false, `/life-shared/${this.state.currentView}`, null, false);
  };

  handleViewUpdate = (viewName) => {
    this.props.history.push({
      pathname: `/life-shared/${viewName}/`,
      state: { prevPath: this.state.currentView },
    });
  };

  handlePostSelect = (postId) => {
    this.props.history.push({
      pathname: `/life-shared/posts/${postId}`,
      state: { prevPath: `/life-shared/${this.state.currentView}` },
    });
  };

  handleSortChange = (sortProperty, order) => {
    const updatedSortColumns = this.updatedSortColumsnOrder(sortProperty, order);
    localStorage.setItem('logSortBy', JSON.stringify({ sortProperty, sortOrder: order }));
    this.setState({ selectedSortColumn: sortProperty, sortColumns: updatedSortColumns, currentPageNumber: 1 });
  };

  updatedSortColumsnOrder = (sortProperty, order) => {
    const updatedSortColumns = updateObject(this.state.sortColumns, {
      [sortProperty]: { sortOrder: order },
    });
    return updatedSortColumns;
  };

  handleLinkClick = (pathName) => {
    this.props.history.push({
      pathname: pathName,
    });
  };

  handleFilterUpdate = (value, filterType) => {
    const locationsOnly = filterType === 'locationsOnly' ? value : false;
    const locations = filterType === 'locationsOnly' ? [] : filterType === 'locations' ? value : this.state.filters.locations;
    const updatedFilters = updateObject(this.state.filters, {
      [filterType]: value,
      locationsOnly,
      locations,
    });
    this.setState({ filters: updatedFilters });
    localStorage.setItem('logFilters', JSON.stringify(updatedFilters));
  };

  handleClearAllFilters = () => {
    const updatedFilters = {
      logIds: this.state.filters.logIds,
      categories: [],
      tags: { locationTags: [], whatTags: [], whoTags: [] },
      memberIds: [],
      keywords: [],
      dateStart: '',
      locations: [],
      fileType: '',
      seasons: [],
      unreadOnly: false,
    };
    this.setState({ filters: updatedFilters });
    localStorage.setItem('logFilters', JSON.stringify(updatedFilters));
  };

  handleLogSelect = (logId) => {
    const updatedLogIds = this.state.filters.logIds.includes(logId)
      ? this.state.filters.logIds.filter((filterLogId) => filterLogId !== logId)
      : [...this.state.filters.logIds].concat([logId]);
    this.handleFilterUpdate(updatedLogIds, 'logIds');
  };

  handleLogsClear = () => {
    this.handleFilterUpdate([], 'logIds');
    this.props.onClearAllLogs();
  };

  handleSelectAllLogs = () => {
    const updatedLogIds = this.props.logs.map((log) => log.Id);
    this.handleFilterUpdate(updatedLogIds, 'logIds');
  };

  handleLogFetch = (pageNumber, sortBy, showMyHistory, showLogs, showTags, postsPerQuery, viewType) => {
    const pageSize = postsPerQuery || this.state.postsPerQuery;
    const userId = this.props.isManagedUser ? this.props.postingAs.UserId : null;
    const sortPostsBy =
      sortBy ||
      (this.state.sortColumns[this.state.selectedSortColumn].sortOrder === 'asc'
        ? `${this.state.selectedSortColumn}_REV`
        : this.state.selectedSortColumn);
    const locationsFilter = this.state.filters.locationsOnly
      ? '(not_empty)'
      : this.state.filters.locations.length > 0
      ? this.state.filters.locations.join('|')
      : null;
    const logIds = this.state.filters.logIds ? this.state.filters.logIds.join('|') : null;
    // we only set isOngoing to true if a user selects an end date of "Ongoing" with no start date. In that case,
    // we will return any post that has an Ongoing end date.
    const tags = [];
    Object.keys(this.state.filters.tags).forEach((tagType) => {
      if (this.state.filters.tags[tagType].length > 0) this.state.filters.tags[tagType].forEach((tag) => tags.push(tag));
    });
    const fileTypeFilter = this.state.filters.fileType;

    this.props.onFetchLog(
      logIds,
      userId,
      showMyHistory,
      showLogs,
      showTags,
      pageNumber,
      pageSize,
      sortPostsBy,
      this.state.filters.categories.join('|'),
      tags.join('|'),
      this.state.filters.memberIds.join('|'),
      this.state.filters.keywords.join('|'),
      this.state.filters.dateStart,
      locationsFilter,
      fileTypeFilter,
      this.state.filters.seasons.join('|'),
      this.state.filters.unreadOnly,
      viewType,
    );
  };

  handleFetchMultiViewColumns = (columnType, columnNames, pageNumber) => {
    const pageSize = this.state.postViewSize === 'small' ? 60 : 20;
    const userId = this.props.isManagedUser ? this.props.postingAs.UserId : null;
    const sortPostsBy = 'DateStart';
    const locationsFilter = this.state.filters.locationsOnly
      ? '(not_empty)'
      : this.state.filters.locations.length > 0
      ? this.state.filters.locations.join('|')
      : null;
    const logIds = this.state.filters.logIds ? this.state.filters.logIds.join('|') : null;
    const tags = [];
    const columnsNamesArray = columnNames || [];
    Object.keys(this.state.filters.tags).forEach((tagType) => {
      if (this.state.filters.tags[tagType].length > 0) this.state.filters.tags[tagType].forEach((tag) => tags.push(tag));
    });
    const fileTypeFilter = this.state.filters.fileType;
    this.props.onFetchMultiViewColumns(
      columnType,
      columnsNamesArray,
      logIds,
      userId,
      true,
      false,
      false,
      pageNumber,
      pageSize,
      sortPostsBy,
      this.state.filters.categories.join('|'),
      tags.join('|'),
      this.state.filters.memberIds.join('|'),
      this.state.filters.keywords.join('|'),
      this.state.filters.dateStart,
      locationsFilter,
      fileTypeFilter,
      this.state.filters.seasons.join('|'),
      this.state.filters.unreadOnly,
    );
  };

  togglePostViewSize = () => {
    let postViewSize = 'small';
    if (this.state.postViewSize === 'small') postViewSize = 'large';
    this.setState({ postViewSize });
    localStorage.setItem('postViewSize', postViewSize);
  };

  toggleGiftsDrafts = () => {
    this.setState({ showGiftsDrafts: !this.state.showGiftsDrafts });
  };

  render = () => {
    let logView = null;
    const logViewContainerClasses = [classes.LogViewContainer];
    if (this.state.currentView === 'category') logViewContainerClasses.push(classes.FixedHeight);

    if (this.state.currentView === 'drafts') {
      logView = <Drafts />;
    } else if (['category', 'people'].includes(this.state.currentView)) {
      const viewType = this.state.currentView === 'category' ? 'categories' : 'memberIds';
      // set columns property based off of the view type
      let columns = [];
      if (this.state.currentView === 'category') {
        columns =
          this.state.filters.categories.length > 0
            ? categoryImages.filter((category) => this.state.filters.categories.includes(category.name))
            : categoryImages;
      } else {
        const viewableLogs = this.props.membersByLog.filter((log) => this.state.filters.logIds.includes(log.Log.Id));
        let allMembersFromViewableLogs = [];
        viewableLogs.forEach((viewableLog) =>
          viewableLog.Users.forEach((member) => {
            if (!allMembersFromViewableLogs.map((m) => m.UserId).includes(member.UserId)) allMembersFromViewableLogs.push(member);
          }),
        );
        // If members are filtered, only show columns for selected members
        if (this.state.filters.memberIds.length > 0)
          allMembersFromViewableLogs = allMembersFromViewableLogs.filter((member) => this.state.filters.memberIds.includes(member.UserId));
        columns = sortArrayOfObjectsAlphabetically(allMembersFromViewableLogs, 'FirstName');
      }

      logView = (
        <SideBySideView
          filters={this.state.filters}
          columns={columns}
          selectedSortColumn={this.state.selectedSortColumn}
          postViewSize={this.state.postViewSize}
          prevPostId={this.state.prevPostId}
          handlePostSelect={this.handlePostSelect}
          handleFetchMultiViewColumns={this.handleFetchMultiViewColumns}
          handleRemoveMultiViewColumns={this.props.onRemoveMultiViewColumns}
          type={viewType}
        />
      );
    } else if (!this.state.filters.logIds || this.state.filters.logIds.length === 0) {
      logView = (
        <div className={classes.NoLogsSelected}>
          <img src={NoLogsSelected} alt="please select logs" />
          <h1>Select one or more logs.</h1>
        </div>
      );
    } else if (this.state.currentView === 'timeline') {
      logView = (
        <Timeline
          currentLogs={this.props.currentLogs}
          currentPageNumber={this.state.currentPageNumber}
          handlePostSelect={this.handlePostSelect}
          handleLogFetch={this.handleLogFetch}
          handleClearPrevPostId={() => this.setState({ prevPostId: null })}
          selectedSortColumn={this.state.selectedSortColumn}
          sortColumns={this.state.sortColumns}
          isManagedUser={this.props.isManagedUser}
          postingAs={this.props.postingAs}
          filters={this.state.filters}
          pageSize={this.state.postsPerQuery}
          prevPostId={this.state.prevPostId}
          postViewSize={this.state.postViewSize}
        />
      );
    }
    if (this.state.currentView === 'list') {
      logView = (
        <List
          currentLogs={this.props.currentLogs}
          currentPageNumber={this.state.currentPageNumber}
          handlePostSelect={this.handlePostSelect}
          handleLogFetch={this.handleLogFetch}
          handleSortChange={this.handleSortChange}
          handleClearPrevPostId={() => this.setState({ prevPostId: null })}
          selectedSortColumn={this.state.selectedSortColumn}
          sortColumns={this.state.sortColumns}
          isManagedUser={this.props.isManagedUser}
          postingAs={this.props.postingAs}
          filters={this.state.filters}
          prevPostId={this.state.prevPostId}
        />
      );
    } else if (this.state.currentView === 'gallery') {
      logView = (
        <Gallery
          currentLogs={this.props.currentLogs}
          currentPageNumber={this.state.currentPageNumber}
          handlePostSelect={this.handlePostSelect}
          handleLogFetch={this.handleLogFetch}
          selectedSortColumn={this.state.selectedSortColumn}
          sortColumns={this.state.sortColumns}
          isManagedUser={this.props.isManagedUser}
          postingAs={this.props.postingAs}
          filters={this.state.filters}
          pageSize={this.state.postsPerQuery}
          prevPostId={this.state.prevPostId}
          postViewSize={this.state.postViewSize}
        />
      );
    }
    return (
      <div className={logViewContainerClasses.join(' ')}>
        {this.state.currentView === 'drafts' ? null : (
          <LogSubNav
            postingAs={this.props.postingAs}
            toggle={this.handleSideDrawerToggle}
            currentView={this.state.currentView}
            postViewSize={this.state.postViewSize}
            currentPath={this.props.match.path}
            currentLogs={this.props.currentLogs}
            logs={this.props.logs}
            selectedSortColumn={this.state.selectedSortColumn}
            sortColumns={this.state.sortColumns}
            filters={this.state.filters}
            tags={this.props.tags}
            importantPlaces={this.props.importantPlaces}
            isManagedUser={this.props.isManagedUser}
            handleAddPostLaunch={this.handleAddPostLaunch}
            handleGiftPostLaunch={this.handleGiftPostLaunch}
            handleViewUpdate={this.handleViewUpdate}
            handleSortChange={this.handleSortChange}
            handleLogSelect={this.handleLogSelect}
            handleLogsClear={this.handleLogsClear}
            handleSelectAllLogs={this.handleSelectAllLogs}
            handleLinkClick={this.handleLinkClick}
            handleFilterUpdate={this.handleFilterUpdate}
            handleClearAllFilters={this.handleClearAllFilters}
            togglePostViewSize={this.togglePostViewSize}
            toggleGiftsDrafts={this.props.onToggleGiftsDraftsModal}
          />
        )}
        {logView}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    logs: state.user.postingAs.Logs,
    tags: state.logs.Tags,
    membersByLog: state.logs.MembersByLog,
    importantPlaces: state.fav.importantPlaces,
    currentLogs: state.logs.currentLogs,
    loading: state.logs.loading === true,
    postingAs: state.user.postingAs,
    isManagedUser: state.user.postingAs.UserId !== state.user.signedInAs.UserId,
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchLog: (
      PageFilterLogId,
      UserId,
      MyHistory,
      ShowLogs,
      ShowTags,
      Page,
      PageSize,
      SortBy,
      PageFilterCat,
      PageFilterTag,
      PageFilterUserId,
      PageFilterKeyword,
      PageFilterDateRange,
      PageFilterLocation,
      PageFilterFileType,
      PageFilterSeason,
      PageFilterRead,
      ViewType,
    ) =>
      dispatch(
        actions.fetchLog(
          PageFilterLogId,
          UserId,
          MyHistory,
          ShowLogs,
          ShowTags,
          Page,
          PageSize,
          SortBy,
          PageFilterCat,
          PageFilterTag,
          PageFilterUserId,
          PageFilterKeyword,
          PageFilterDateRange,
          PageFilterLocation,
          PageFilterFileType,
          PageFilterSeason,
          PageFilterRead,
          ViewType,
        ),
      ),
    onFetchMultiViewColumns: (
      ColumnType,
      ColumnNames,
      PageFilterLogId,
      UserId,
      MyHistory,
      ShowLogs,
      ShowTags,
      PageNum,
      PageSize,
      SortBy,
      PageFilterCat,
      PageFilterTag,
      PageFilterUserId,
      PageFilterKeyword,
      PageFilterDateRange,
      PageFilterLocation,
      PageFilterFileType,
      PageFilterSeason,
      PageFilterRead,
    ) =>
      dispatch(
        actions.fetchMultiViewColumns(
          ColumnType,
          ColumnNames,
          PageFilterLogId,
          UserId,
          MyHistory,
          ShowLogs,
          ShowTags,
          PageNum,
          PageSize,
          SortBy,
          PageFilterCat,
          PageFilterTag,
          PageFilterUserId,
          PageFilterKeyword,
          PageFilterDateRange,
          PageFilterLocation,
          PageFilterFileType,
          PageFilterSeason,
          PageFilterRead,
        ),
      ),
    onRemoveMultiViewColumns: (ColumnType, ColumnName) => dispatch(actions.removeMultiViewColumns(ColumnType, ColumnName)),
    onClearAllLogs: () => dispatch(actions.clearAllLogs()),
    onInitPostForm: (postId, isDraft, isGift, redirectPath, UserId, isManagedUser) =>
      dispatch(actions.initPostFormStart(postId, isDraft, isGift, redirectPath, UserId, isManagedUser)),
    onFetchTags: () => dispatch(actions.fetchTagsForLogs()),
    onFetchMembersForLogs: () => dispatch(actions.fetchMembersForLogs()),
    onFetchImportantPlaces: () => dispatch(actions.fetchImportantPlaces()),
    onToggleGiftsDraftsModal: () => dispatch(actions.toggleGiftsDraftsModal()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Log));
